import { useCallback } from "react"
import { toast } from "sonner"

import { openTikTokAffiliateLink } from "@/modules/helpers/tap-utils"
import { copyToClipboard } from "@/modules/helpers/tap-utils"
import { sendOpenLink } from "@/modules/helpers/utils"

/**
 * Hook to handle affiliate product actions
 * @param productId - Product ID for tracking
 * @param productLink - Product link to copy/attach
 * @param onSaveLink - Optional callback when link is saved (for tracking)
 * @returns Object with handlers for affiliate actions
 */
export function useAffiliateActions(
  productId?: string,
  productLink?: string,
  onSaveLink?: (id: string) => void
) {
  const handleCopyLink = useCallback(async () => {
    if (!productLink) return

    const success = await copyToClipboard(productLink)
    if (success) {
      toast.success("Đã sao chép liên kết", { duration: 1000 })
      if (productId && onSaveLink) {
        onSaveLink(productId)
      }
    }
  }, [productLink, productId, onSaveLink])

  const handleAttachAffiliate = useCallback(() => {
    if (!productLink) return
    openTikTokAffiliateLink(productLink)
  }, [productLink])

  return {
    handleCopyLink,
    handleAttachAffiliate
  }
}

/**
 * Generate TikTok Showcase URL for adding product
 * @param productLink - Product link to add to showcase
 * @returns TikTok Showcase URL
 */
export function getTikTokShowcaseAddProductUrl(productLink: string): string {
  return `snssdk1180://lynxview?bundle=url-add-product/template.js&channel=tea_selection_page&dynamic=1&hide_nav_bar=1&product_url=${productLink}`
}

/**
 * Open TikTok Showcase to add product
 * @param productLink - Product link to add to showcase
 */
export function openTikTokShowcaseAddProduct(productLink: string): void {
  const url = getTikTokShowcaseAddProductUrl(productLink)
  sendOpenLink(url)
}
